import History from '../../util/history';

class RouterService {
    constructor() {

    }

    gotoPath (pathName) {
        if (History.location.pathname !== pathName) {
            History.push({
                pathname: pathName
            });
        }
    }
}

export default new RouterService();